var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.Background,style:({ padding: _vm.title ? '10px' : '' })},[(_vm.title || _vm.titles)?_c('div',{staticClass:"flex-row start middle",staticStyle:{"padding":"10px"}},[_c('div',{staticStyle:{"color":"#000","font-weight":"700","font-size":"18px"}},[_vm._v(" "+_vm._s(_vm.title || _vm.titles)+" ")])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }